module.exports = "<div class=\"form-box form-response\">\r\n  <div class=\"form-response\">\r\n    <div class=\"item\">\r\n      <div class=\"form-item-title\" ng-class=\"formFieldResponse.required\">\r\n        Upload your file\r\n      </div>\r\n      <div class=\"form-item-description\">\r\n        This is a file upload item\r\n      </div>\r\n      <button class=\"button button-light\" translate=\"forms.display.choose.file\"></button>\r\n    </div>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/field-templates/file/response-edit.html
// module id = 3432
// module chunks = 0